module.exports = __webpack_public_path__ + "static/media/adorable-animal-beach-928449.5f0aed4b.jpg";